/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TaskByClientsResp } from '../models/task-by-clients-resp';
import { TaskDto } from '../models/task-dto';

@Injectable({
  providedIn: 'root',
})
export class TasksService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation taskByClient
   */
  static readonly TaskByClientPath = '/tasks/client/{uuid}';

  /**
   * Get user tasks
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskByClient()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskByClient$Response(params: {

    /**
     * user uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<TaskByClientsResp>> {

    const rb = new RequestBuilder(this.rootUrl, TasksService.TaskByClientPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TaskByClientsResp>;
      })
    );
  }

  /**
   * Get user tasks
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `taskByClient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskByClient(params: {

    /**
     * user uuid
     */
    uuid: string;
  }): Observable<TaskByClientsResp> {

    return this.taskByClient$Response(params).pipe(
      map((r: StrictHttpResponse<TaskByClientsResp>) => r.body as TaskByClientsResp)
    );
  }

  /**
   * Path part for operation taskDelete
   */
  static readonly TaskDeletePath = '/tasks/{uuid}';

  /**
   * Delete a task
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskDelete$Response(params: {

    /**
     * task uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, TasksService.TaskDeletePath, 'delete');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * Delete a task
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `taskDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskDelete(params: {

    /**
     * task uuid
     */
    uuid: string;
  }): Observable<{
'success'?: boolean;
}> {

    return this.taskDelete$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

  /**
   * Path part for operation taskPut
   */
  static readonly TaskPutPath = '/tasks';

  /**
   * Task update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskPut$Response(params: {
    body: TaskDto
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, TasksService.TaskPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * Task update
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `taskPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskPut(params: {
    body: TaskDto
  }): Observable<{
'success'?: boolean;
}> {

    return this.taskPut$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

}
